import React from 'react';
import './_softErrorModalContent.scss'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { bodyTextRenderOptions } from '@/contentful/helper';

const SoftErrorModalContent = (props: any) => {

  const rmoRedirect = () => {
    location.href = 'https://kampagne.yousee.dk/simo-rej-rmo'
  }

  return (
      <div className="d-flex flex-column justify-content-center">
        <div className="text-center pb-3 line-height-24">
        {documentToReactComponents(props?.cms?.content?.json, bodyTextRenderOptions)}
        </div>
        <div className="d-flex pb-3 justify-content-center">
        <button
          className="ys-button ys-button--cta"
          onClick={() => rmoRedirect}
        >
          <span className="ys-button__text">Ring mig op</span>
        </button>
        </div>
        <a href="." className="d-flex justify-content-center">Genindlæs hjemmesiden</a>
      </div>
  );
};

export default SoftErrorModalContent;
